function TableRowSkeleton() {
  return (
    <div role="status" className="space-y-4 animate-pulse max-w-lg">
      <div className="h-3 bg-gray-300 rounded-full   w-24"></div>
    </div>
  );
}

export default TableRowSkeleton;
